import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { CHECKOUT_URL } from '../data/content';
const rows: [string, string][] = [['Vol 1 — Elements of Art™', '$27 Value'], ['Vol 2 — Drawing & Illustration™', '$27 Value'], ['Vol 3 — Color, Painting & Mixed Media™', '$27 Value'], ['Vol 4 — Principles of Design™', '$27 Value'], ['Vol 5 — Art, Artists & Visual Cultures™', '$27 Value'], ['Vol 6 — Art Projects & Creative Challenges™', '$27 Value'], ['Bonus 1 — Art Assessment Made Simple™', '$47 Value'], ['Bonus 2 — The Art Teacher Planner™', '$47 Value'], ['Bonus 3 — 10-Minute Art Rescue™', '$27 Value'], ['Bonus 4 — Art Classroom Visuals™', '$37 Value'], ['Bonus 5 — Student Art Portfolio™', '$27 Value']];
export function ValueStack() {
  return <section id="offer" className="w-full scroll-mt-20 bg-navy-mid px-5 py-10 sm:py-16" data-id="element-210" data-mp="30wtuay42mch7">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-[600px]" data-id="element-211" data-mp="35pwqzf45a21m">
        <h2 className="text-center font-display text-2xl font-bold text-white sm:text-4xl" data-id="element-212" data-mp="235fxlklizw52">
          Everything You Need to Support the Art Year—in One Connected System.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-white/70 sm:text-base" data-id="element-213" data-mp="2c5kydbw7rwa9">
          The six core volumes give you the teaching content. The five professional bonuses help with
          the planning, assessment, quick classroom needs, visual support and student progress that
          happen around it.
        </p>
        <div className="mt-6 rounded-2xl border border-gold/45 bg-navy p-4 sm:mt-8 sm:p-6" data-id="element-214" data-mp="2h68ugbzav3bc">
          <ul data-id="element-215" data-mp="rr2hx30xen04">
            {rows.map(([label, price]) => <li key={label} className="flex items-center justify-between gap-3 border-b border-dashed border-gold/30 py-2 last:border-b-0 sm:py-2.5" data-id="element-216" data-mp="rru9m2rek0l4">
                <span className="text-[13px] text-white/85 sm:text-sm" data-id="element-217" data-mp="2muh9hptt32zh">{label}</span>
                <span className="shrink-0 text-[13px] font-medium text-white/65 sm:text-sm" data-id="element-218" data-mp="2rrh5t90usrde">
                  {price}
                </span>
              </li>)}
          </ul>
          <div className="my-4 h-px w-full bg-gold/45" data-id="element-219" data-mp="30sp1rkfwdg4b" />
          <div className="flex items-center justify-between" data-id="element-220" data-mp="30ui6gu6y9q9o">
            <span className="text-[13px] text-white/65 sm:text-sm" data-id="element-221" data-mp="35stk7g0d8kx6">Combined value</span>
            <span className="text-lg font-medium text-white/55 line-through sm:text-xl" data-id="element-222" data-mp="3aql9s3djfuy7">
              $347 USD
            </span>
          </div>
          <div className="mt-4 flex flex-col items-center rounded-xl border border-gold/30 bg-navy-mid py-5 text-center sm:py-6" data-id="element-223" data-mp="3fid0qf0lw2ov">
            <span className="text-sm font-medium text-gold" data-id="element-224" data-mp="3oijdfyohcymz">Today</span>
            <span className="font-display text-5xl font-bold text-gold sm:text-6xl" data-id="element-225" data-mp="3okck3dz3fiuz">$27 USD</span>
            <p className="mt-2 px-4 text-xs text-white/65 sm:text-sm" data-id="element-226" data-mp="3thvzwibfw3p1">
              Get all 6 core volumes + 5 professional teacher bonuses for one payment of $27 USD.
            </p>
          </div>
        </div>
        <div className="mt-6 sm:mt-8" data-id="element-227" data-mp="2j58xhleac0n">
          <div className="mb-6 flex flex-col items-center text-center sm:mb-8" data-id="element-228" data-mp="3tmtyj30e8d4h">
            <span className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-229" data-mp="3pm1ldyoeho2x">
              Take a look inside
            </span>
            <h3 className="mt-2 font-display text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-230" data-mp="q5lj0pt51pcx">
              Inside <span className="text-gold" data-id="element-231" data-mp="l83gpi9mm8dw">THE COMPLETE ART YEAR™</span>
            </h3>
            <p className="mt-4 text-base font-bold text-white sm:text-lg" data-id="element-232" data-mp="gfs7tpwwrc97">
              6 Core Volumes + 5 Professional Teacher Bonuses
            </p>
            <p className="mt-1 text-sm text-white" data-id="element-233" data-mp="18x4gyi8b2d83">
              See the lessons, visual references, projects, planning tools and assessment resources
              included inside the system.
            </p>
            <div className="mt-5 w-full overflow-hidden rounded-xl border-2 border-gold bg-navy sm:mt-6" data-id="element-234" data-mp="ooo6t1z2w1le">
              <div className="relative aspect-square w-full" data-id="element-235" data-mp="to0rph6e2ylc">
                <img src="https://cdn.magicpatterns.com/patterns/generated-images/bc39cdf3-b0f9-4902-bb8a-2f799b6527a8.jpg" alt="Preview of interior pages from THE COMPLETE ART YEAR: Elements of Art reference, shading and perspective technique pages, color relationships, composition comparisons, an art-analysis page, project planning, an assessment rubric, the 36-week planning roadmap, quick-activity cards, a classroom poster and a student portfolio reflection page" width="600" height="600" sizes="(max-width: 767px) 100vw, 600px" loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-236" data-mp="tlemho6z0v6a" />
              </div>
            </div>
            <p className="mt-3 text-xs text-white/70" data-id="element-237" data-mp="1qdi6clncnuz6">
              One-Time Payment · No Subscription · Instant Digital Access · Lifetime Access
            </p>
          </div>
          <CTAButton label="GET THE COMPLETE ART YEAR™" href={CHECKOUT_URL} data-id="element-238" data-mp="3fum469zvbi2m" />
          <TodayOfferCard data-id="element-239" data-mp="3fssyawx2x1vo" />
        </div>
      </motion.div>
    </section>;
}